import { render, staticRenderFns } from "./TermsCard.vue?vue&type=template&id=2b2d7fe0"
import script from "./TermsCard.vue?vue&type=script&lang=js"
export * from "./TermsCard.vue?vue&type=script&lang=js"
import style0 from "./TermsCard.vue?vue&type=style&index=0&id=2b2d7fe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports